import { render, staticRenderFns } from "./ServiceTestSuitModal.vue?vue&type=template&id=3edbee92"
import script from "./ServiceTestSuitModal.vue?vue&type=script&lang=js"
export * from "./ServiceTestSuitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports